import InterItalicText from './InterItalicText';

export default InterItalicText;
